export const TO = async (promise) => {
	let result = null;
	let errors = null;

	try {
		result = await promise;

		return [errors, result];

	} catch (error) {

		return [errors, result];
        
	}
};
